import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Link} from '@cred/react-link'

class ChildDisclosure extends Component {
  static propTypes = {disclosure: PropTypes.object.isRequired}

  render() {
    const {disclosure} = this.props

    return (
      <Link onClick={event => this.openModal(event, disclosure.slug)}>
        {disclosure.label}
      </Link>
    )
  }

  openModal(event, slug) {
    const {actions} = this.props

    event.preventDefault()
    actions.openModalMulti(`child-disclosure-${slug}`)
  }
}

export default ChildDisclosure
